module.exports = __webpack_public_path__ + "img/mobile@3x.32ec9fee.jpg";